import React from 'react'

type MainWrapperProps = {
  children: React.ReactNode
  className?: string
  fullWidth?: boolean
}

const MainWrapper = ({
  children,
  className,
  fullWidth,
  ...rest
}: MainWrapperProps) => (
  <div
    className={`mx-auto my-0 ${!fullWidth ? `max-w-screen-3xl` : ''} ${
      className || ''
    }`}
    {...rest}
  >
    {children}
  </div>
)

export default MainWrapper
